import { render, staticRenderFns } from "./GeneralCuttingReport.vue?vue&type=template&id=5871c1b3&scoped=true"
import script from "./GeneralCuttingReport.vue?vue&type=script&lang=js"
export * from "./GeneralCuttingReport.vue?vue&type=script&lang=js"
import style0 from "./GeneralCuttingReport.vue?vue&type=style&index=0&id=5871c1b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5871c1b3",
  null
  
)

export default component.exports